const lang = {
    action: {
        language: 'en',
        finishing: 'Finishing',
        only_admin: 'Only account owners can change it',
        add_filter: 'Add filter',
        add: 'Add',
        addEvent: 'Add Schedule',
        addLevel: 'Add Difficulty Level',
        addQuizCategories: 'Add Quiz Categories',

        back: 'Go Back',
        bulk_actions: '1 item selected |||| {{smart_count}} items selected',
        cancel: 'Cancel',
        clear_input_value: 'Clear value',
        clone: 'Clone',
        confirm: 'Confirm',
        create: 'Create',
        delete: 'Delete',
        edit: 'Edit',
        export: 'Export',
        find: 'Find',
        list: 'List',
        refresh: 'Refresh',
        remove_filter: 'Remove filter',
        remove: 'Remove',
        save: 'Save',
        search: 'Search',
        show: 'Show',
        sort: 'Sort',
        undo: 'Undo',
        expand: 'Expand',
        close: 'Close',
        viewDetail: 'View Detail',
        bulkInsertStudent: 'Students Bulk Insert',
        bulkInsertTeacher: 'Teachers Bulk Insert',
        promoteGradeStudent: 'Promote to Next Grade',
        finish: 'Finish',
        preview: 'Preview',
        addAssigment: 'Add Assigment',
        verification: 'Verification',
    },
    boolean: {
        true: 'Yes',
        false: 'No',
        null: '',
        aktif: 'Active',
        tidakAktif: 'Not Active',
        banner: {
            internal: 'Internal Content',
            website: 'Website',
        },
        epustaka: {
            private: 'Private Epustaka',
            public: 'Public Epustaka',
            perorangan: 'Personal',
            lembaga: 'Institution',
        },
        book: {
            private: 'Private Book',
            public: 'Public Book',
        },
    },
    page: {
        create: 'Create {{name}}',
        dashboard: 'Dashboard',
        edit: '{{name}} #{{id}}',
        error: 'Something went wrong',
        list: '{{name}}',
        loading: 'Loading',
        landing: 'Landing Page',
        landinginfo: 'Sample Landing Page',
        not_found: 'Not Found',
        show: '{{name}} #{{id}}',
        page1: 'Page 1',
        page2: 'Page 2',
    },
    input: {
        bulk: {
            student: 'Upload student XLSX file',
            teacher: 'Upload teacher XLSX file',
        },
        file: {
            upload_several:
                'Drop some files to upload, or click to select one.',
            upload_single: 'Drop a file to upload, or click to select it.',
        },
        image: {
            upload_several:
                'Drop some pictures to upload, or click to select one.',
            upload_single: 'Drop a picture to upload, or click to select it.',
        },
        references: {
            all_missing: 'Unable to find references data.',
            many_missing:
                'At least one of the associated references no longer appears to be available.',
            single_missing:
                'Associated reference no longer appears to be available.',
        },
        password: {
            toggle_visible: 'Hide password',
            toggle_hidden: 'Show password',
        },
        addAcount: 'Choose Account',
        addAccountTitle: 'Add School Admin',
        addAcountPlaceholder: 'Select an account to be the school admin',
        MigrationUserPlaceholder: 'Select an account to migrate',
        confirmAddAdmin: 'Are you sure you want to add as a school admin?',
        confirmMigration: 'Migrate user data to your school?',
    },
    message: {
        about: 'About',
        are_you_sure: 'Are you sure?',
        bulk_delete_content:
            'Are you sure you want to delete this {{name}}? |||| Are you sure you want to delete these {{smart_count} items?',
        bulk_delete_title:
            'Delete {{name}} |||| Delete {{smart_count}} {{name}}',
        delete_content: 'Are you sure you want to delete this item?',
        delete_title: 'Delete Confirmation',
        details: 'Details',
        error:
            "A client error occurred and your request couldn't be completed.",
        invalid_form: 'The form is not valid. Please check for errors',
        loading: 'The page is loading, just a moment please',
        no: 'No',
        not_found: 'Either you typed a wrong URL, or you followed a bad link.',
        yes: 'Yes',
        verification_success: 'Verification Successful',
        successAddADmin: 'School admin data added',
        successRemoveADmin: 'School admin data removed',
        successMigration: 'User data migration successful',
        hour: 'Hour',
        minute: 'Minute',
    },
    navigation: {
        no_results: 'No results found',
        no_more_results:
            'The page number {{page}} is out of boundaries. Try the previous page.',
        page_out_of_boundaries: 'Page number {{page}} out of boundaries',
        page_out_from_end: 'Cannot go after last page',
        page_out_from_begin: 'Cannot go before page 1',
        page_range_info: '{{offsetBegin}}-{{offsetEnd}} of {{total}}',
        page_rows_per_page: 'Rows per page:',
        next: 'Next',
        prev: 'Prev',
        fillAnswerForm: 'Fill answer form',
        fillQuestionForm: 'Fill question form',
    },
    auth: {
        auth_check_error: 'Please login to continue',
        user_menu: 'Profile',
        username: 'Username',
        password: 'Password',
        sign_in: 'Sign in',
        sign_in_error: 'Authentication failed, please retry',
        logout: 'Logout',
        lock: 'Lock Account',
        setting: 'Settings',
        profile: 'Profile',
        account: 'Account',
    },
    notification: {
        updated: 'Element updated |||| {{smart_count}} elements updated',
        created: 'Element created',
        dataCreated: 'Data created',
        deleted: {
            single: 'Element deleted',
            multiple: '{{smart_count}} elements deleted',
        },
        bad_item: 'Incorrect element',
        item_doesnt_exist: 'Element does not exist',
        http_error: 'Server communication error',
        data_provider_error:
            'dataProvider error. Check the console for details.',
        i18n_error: 'Cannot load the translations for the specified language',
        canceled: 'Action cancelled',
        logged_out: 'Your session has ended, please reconnect.',
    },
    validation: {
        required: 'Required',
        minLength: 'Must be {{min}} characters at least',
        maxLength: 'Must be {{max}} characters or less',
        maxImage: 'Image must smaller than 2MB!',
        maxAudio: 'Audio must smaller than 50MB!',
        maxVideo: 'Video must smaller than 250MB!',
        minValue: 'Must be at least {{min}}',
        maxValue: 'Must be {{max}} or less',
        number: 'Must be a number',
        email: 'Must be a valid email',
        emailExist: 'Email has been used',
        emailBulkExist: 'There are emails that have been used in bulk data',
        oneOf: 'Must be one of: {{options}}',
        regex: 'Must match a specific format (regexp): {{pattern}}',
        cantPastCurrentYear: 'Can not past current year.',
        cantBeSmallerThanYearStart: 'Can not be smaller than the start year',
        dataExist: 'Data already exists',
        gradeNotExist: 'Empty Class Data, Please Fill in First Class Data',
        dataBulkNotValid:
            'There is invalid data / file does not use the specified format.',
        dataEmpty: 'Data is invalid or empty',
    },
    menu: {
        menuUtama: 'Main Menu',
        halamanUtama: 'Main Page',
        content: 'Content',
        school: 'School',
        exam: 'Exam',
        config: 'Configuration',
        onlineTraining: 'Online Training',
        edoo: 'Edoo Administrator',
        jadwal: 'Subject Schedule',
        jadwalPelatihan: 'Training Schedule',
        event: 'School Event',
        pendaftar: 'Registrant',
        absensi: 'Student Attendance',
        aktiPustaka: 'Epustaka Activity',
        aktiDonasi: 'Donation Activity',
        aktiAdmin: 'Admin Activity',
        ruangan: 'Rooms',
        bankSoal: 'Question Bank',
        migrasi: 'Mutation (Teacher/Student)',
        examPackage: 'Exam Package',
        stats: {
            siswaHadir: `Today's Students Present`,
            userAktif: `Today's User Active`,
            peminjaman: `Today's Lendings`,
        },
        admin: {
            buku: 'Book',
            video: 'Video',
            audio: 'Audio',
            multimediaCategory: 'Multimedia Category',
            tahunAjaran: 'Year Academic',
            jurusan: 'Grade Major',
            kelas: 'Grade',
            subKelas: 'Sub-Kelas',
            pelajaran: 'School Subject',
            akademik: 'School Academic',
            daftarSiswa: 'Student List',
            daftarGuru: 'Teacher List',
            userMigrate: 'Mutation (Teacher/Student)',
            settingAdminSekolah: 'School Admin Settings',
            kalender: 'Academic Calender',
            banner: 'Banner',
            pengajar: 'Teacher',
            ujian: {
                KategoriQuiz: 'Quiz Categories',
                configQuiz: 'Quiz Configuration ',
                questionLevel: 'Level of Difficulty',
            },
            donation: 'Donation',
        },
        superAdmin: {
            daftarSekolah: 'School List',
        },
        guru: {
            tugas: 'Task',
            nilai: 'Score',
            bukuAjar: 'Textbook',
            jadwal: 'Teaching Schedule',
            event: 'Event',
        },
    },
    column: {
        aksi: 'Action',
        namaGuru: `Teacher's Name`,
        namaSiswa: `Student's Name`,
        tahunAjaran: {
            tahunAjaran: 'Year Academic',
            semester: 'Semester',
            status: 'Status',
        },
        jurusan: {
            namaJurusan: 'Major Name',
            deskripsi: 'Description',
        },
        kelas: {
            namaKelas: 'Grade Name',
            deskripsi: 'Description',
            classScope: 'Grade Scope',
            internalSekolah: 'Internal School',
            public: 'Public',
        },
        ruangan: {
            namaRuangan: 'Room Name',
            deskripsi: 'Description',
        },
        pelajaran: {
            mataPelajaran: 'Subject Name',
            subjectPrice: 'Price',
        },
        user: {
            nama: 'Name',
            customNama: '{{role} Name',
            email: 'Email',
            telepon: 'Telephone',
            kota: 'City',
            alamat: 'Address',
            nis: 'NIS',
            nik: 'NIK',
            bio: 'Biography',
            avatar: 'Profile Picture',
            StatusPengguna: 'User Status',
            guest: 'Guest',
            admin: 'School Admin',
            teacher: 'Teacher',
            student: 'Student',
        },
        jadwal: {
            tanggal: 'Date',
            waktuMulai: 'Start Time',
            waktuSelesai: 'End Time',
            waktu: 'Times',
        },
        event: {
            event_name: 'Event Name',
            event_description: 'Description',
            event_date: 'Date Event',
            event_start: 'Start Date',
            event_end: 'End Date',
            event_image_url: 'Picture',
            event_link: 'Website Link',
        },
        banner: {
            judul: 'Title',
            deskripsi: 'Description',
            tautan: 'Link',
            tipeTautan: 'Link Type',
            gambar: 'Image',
            status: 'Status',
        },
        sekolah: {
            namaSekolah: `School's Name`,
            email: 'Email',
            alamat: 'Address',
            namaAdmin: `Admin's Name`,
            status: 'Status',
            provinsi: 'Province',
            kabupaten: 'Regency',
            telepon: 'Telephone',
            logo: 'School Logo',
        },
        buku: {
            category: 'Book Category',
            author: 'Author',
            digitalIsbn: 'Digital ISBN',
            physicalIsbn: 'Physical ISBN',
            usingDrm: 'DRM',
            url: 'Link',
            bookTitle: 'Book Title',
            synopsis: 'Synopsis',
            body: 'Body',
            status: 'Status',
            createdAt: 'Created At',
            file: `Book's File`,
            cover: `Book's Cover`,
            totalPages: 'Total Pages',
            epustaka: 'EPustaka',
            fileExtension: 'File Extension',
        },
        author: {
            author_name: 'Author Name',
            author_phone: 'Author Phone',
            author_email: 'Author Email',
            author_address: 'Author Address',
            category_id: 'Category',
        },
        multimediaCategory: {
            category_name: 'Category Name',
            category_description: 'Category Description',
            is_active: 'Status',
        },
        video: {
            judul: 'Judul',
            category: 'Kategori',
            media_description: 'Deskripsi',
            media_thumbnail_url: 'Thumbnail',
            media_file_url: 'File',
            media_duration: 'Durasi',
        },
        epustaka: {
            epustaka_name: 'Epustaka Name',
            epustaka_phone: 'Phone',
            epustaka_email: 'Epustaka Email',
            epustaka_category: 'Epustaka Category',
            epustaka_address: 'Epustaka Address',
            epustaka_aboutus: 'About Epustaka',
            epustaka_isactive: 'Status',
            epustaka_isprivate: 'Type',
            epustaka_logo: 'Logo',
        },
        teacherAssignment: {
            assignmentName: 'Assignment Name',
            assignmentDescription: 'Assignement Description',
            assignmentDueDate: 'Due Date',
            assignmentMaterial: 'Assignment Material',
        },
        profile: {
            profileUser: 'User Profile',
            profileSchool: 'School Profile',
            editProfile: 'Edit Profile User',
            editProfileSchool: 'Edit Profile School',
        },
        question: {
            question: 'Question',
            questionDetail: 'Question Detail',
            competence: 'Competence',
            questionSource: 'Question Source',
            createdBy: 'Created by',
            publish: 'Publish',
        },
        questionLevel: {
            levelName: 'Level',
            levelDescription: 'Description',
            levelWeight: 'Level Weight',
        },
        questionScope: {
            scopeName: 'Scope',
            subScopeName: 'Scope Type',
        },
        subScope: {
            school: 'School',
            province: 'Province',
            regency: 'Regency',
            national: 'National',
        },
        answer: {
            answer: 'Answer for',
            answerDetail: 'Answer',
            answerKey: 'Answer Key',
        },
        quizCategories: {
            category_name: 'Category Name',
        },
        quiz: {
            quizDetail: 'Quiz Detail',
            quizCode: 'Quiz Code',
            quizStart: 'Start Time',
            quizEnd: 'End Time',
            quizTitle: 'Quiz Title',
            quizDuration: 'Quiz Duration',
            numberOfQuestions: 'Number of Questions',
            quizCreatedBy: 'Created by',
            isActive: 'Published?',
            times: 'Times',
        },
        donation: {
            idTransaction: 'ID Transaction',
            donationDate: 'Date',
            donationExiredDate: 'Expired date',
            totalPay: 'Total Pay',
            status: 'Status',
            paymentMethod: 'Payment method',
            donationBy: 'Donated by',
            donationTo: 'Donated to',

            jenis: 'Type',
            judul: 'Title',
            cover: 'Cover',
            penulis: 'Author',
            tahunTerbit: 'Publication Year',
        },
    },
    filter: {
        ganjil: 'Odd',
        genap: 'Even',
    },
    status: {
        active: 'Active',
        nonActive: 'Not Active',
        inReview: 'In Review',
        disabled: 'Disabled',
    },
}

export default lang
